/**
 * Session hygiene for session-derived reducers (BUG-2026-211).
 *
 * Volto's default apiExpanders make GET_CONTENT the only refresh vehicle for
 * state.actions and state.navigation (View.jsx and VLT's Navigation both skip
 * their standalone fetches when the expander is configured). After a
 * client-side logout on an all-private tenant, the post-logout anonymous
 * GET_CONTENT 401s, GET_CONTENT_FAIL touches neither reducer, and the
 * logged-in payloads survive — the header keeps "Log out" and the nav keeps
 * the private items until a hard reload.
 *
 * Root fix: session-derived state must not outlive the session. These wraps
 * delegate everything to the core reducers, and on logout (SUCCESS and FAIL —
 * mirroring the core userSession reducer, which clears the token on both)
 * reset to the core initial state by delegating to coreReducer(undefined, {}).
 * No initial-state constants are copied, so core upgrades stay authoritative.
 *
 * On public tenants the reset is transient: the post-logout anonymous
 * GET_CONTENT succeeds and its expander payload immediately refills both.
 */
import { LOGOUT } from '@plone/volto/constants/ActionTypes';
import actions from '@plone/volto/reducers/actions/actions';
import navigation from '@plone/volto/reducers/navigation/navigation';

const resetOnLogout = (coreReducer) => (state, action = {}) =>
  action.type === `${LOGOUT}_SUCCESS` || action.type === `${LOGOUT}_FAIL`
    ? coreReducer(undefined, {})
    : coreReducer(state, action);

export const actionsWithSessionHygiene = resetOnLogout(actions);
export const navigationWithSessionHygiene = resetOnLogout(navigation);
